<template>
  <v-container
    id="templates"
    fluid
    tag="section"
  >
    <base-v-component
      :heading="$t('templates')"
      :subtitle="$t('templates-subtitle')"
    />
    <div class="d-flex align-baseline">
      <v-tooltip bottom class="flex-column">
        <template v-slot:activator="{ on, attrs }">
          <v-btn 
            small
            fab
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="onCreateItem"
          >
            <v-icon>mdi-upload</v-icon>
          </v-btn>
          </template>
        <span>{{ $t('template-upload') }}</span>
      </v-tooltip>
      
      <v-tooltip bottom class="flex-column">
        <template v-slot:activator="{ on, attrs }">
          <v-btn 
            :disabled="!selected.length"
            small
            fab
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="dialogMultipleDelete=true"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          </template>
        <span>{{ $t('delete') }}</span>
      </v-tooltip>

      <!--
      <v-tooltip bottom class="flex-column">
        <template v-slot:activator="{ on, attrs }">
          <v-btn 
            small
            fab
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="$router.push({ name: 'templates.instructions'})"
          >
            <v-icon>mdi-help</v-icon>
          </v-btn>
          </template>
        <span>{{ $t('instructions') }}</span>
      </v-tooltip>
      -->

      <v-text-field
        v-model="search"
        class="flex-column pl-2"
        append-icon="mdi-magnify"
        label="Search"
        solo-inverted
        flat
        single-line
        hide-details
      />
    </div>
    <template>
      <v-card>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="templates"
          :search="search"
          :show-select="true"
          sort-by="name"
          class="elevation-1 pa-3"
        >
          <template v-slot:item.updated="{item}">
            {{ $moment(item.updated).format('YYYY-MM-DD') }}
          </template>
          <template v-slot:item.created="{item}">
            {{ $moment(item.created).format('YYYY-MM-DD') }}
          </template>
          <template v-slot:item.options="{item}">
          <v-menu 
            transition="slide-x-transition"
            bottom
            right
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                class="no-background primary--text"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(option, index) in options"
                :key="index"
                @click="onOption(option.id, item)"
              >
                <v-list-item-title>{{ option.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        </v-data-table>
      </v-card>
    </template>

    <!-- DIALOG CONFIRM DELETE -->
    <v-dialog v-model="dialogMultipleDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('delete-multiple-items') }}</v-card-title>
        <v-card-text>{{ $t('delete-multiple-items-confirm') }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogMultipleDelete = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="error" text @click="onDeleteMultipleItems">{{ $t('delete') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG UPLOAD -->
   <v-dialog
      v-model="dialogUpload"
      max-width="400"
    >
      <v-card>
        <v-card-title class="headline">
          {{ $t('template-upload') }}
        </v-card-title>
        <v-card-text>
          <v-container>
            <p>{{ $t('template-upload-description')}}</p>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="editingObject.name"
                  :rules="[rules.required]"
                  :disabled="editingObject.editMode"
                  :label="$t('name')"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-file-input 
                  accept=".docx" 
                  show-size
                  :label="$t('template-file')"
                  prepend-icon="mdi-file"
                  v-model="editingObject.file"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialogUpload = false"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="onCreateEditTemplate"
          >
            {{ $t('upload') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

     <!-- DIALOG CONFIRM DELETE -->
    <v-dialog
      v-model="dialogConfirmDelete"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          {{ $t('template-delete') }}
        </v-card-title>
        <v-card-text>{{ $t('template-delete-confirm') }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialogConfirmDelete = false"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            color="error"
            text
            @click="deleteTemplate"
          >
            {{ $t('delete') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </v-container>
</template>

<script>
  import StorageService from '@/services/StorageService'

  export default {
    name: 'Templates',

    components: {
    },

    data: () => ({
      rules: {
        required: (value) => !!value || "Required.",
      },
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Updated', value: 'updated' },
        { text: 'Created', value: 'created' },
        {
          text: "",
          value: "options",
          sortable: false,
          width: "2%",
          align: "right",
        },
        //{ text: '', value: 'action', sortable: false, align: 'end' },
      ],
      options: [
        {
          title: 'Download',
          id: 'download'
        },
        {
          title: 'Edit',
          id: 'edit'
        },
        {
          title: 'Delete',
          id: 'delete'
        },
      ],
      search: '',
      selected: [],
      editingObject: {},
      dialogUpload: false,
      dialogConfirmDelete: false,
      dialogMultipleDelete: false,
      storageService: null,
    }),
    created () {
      this.storageService = new StorageService()
      this.resetEditingObject()
      this.fetchTemplates()
    },
    watch: {
      activeProject(newActiveProject) {
        if (newActiveProject.id) {
          this.refresh()
        }
      }
    },
    computed: {
      templates () {
        return this.$store.getters['templates/getTemplates']
      },
      access() {
        return this.$store.getters["company/getAccess"];
      },
      user() {
        return this.$store.getters["user/getUser"];
      },
      company() {
        return this.$store.getters['company/getCompany']
      },
      activeProject () {
        return this.$store.getters['projects/getActiveProject']
      },
    },
    methods: {
      resetEditingObject () {
        this.editingObject = {
          name: '',
          file: null,
          editMode: false,
        }
      },
      refresh () {
        this.resetEditingObject();
        this.$store.dispatch('templates/clearTemplates')
          .then(() => {
            this.fetchTemplates();
          })
      },
      verifyActiveProject () {
        if(!this.activeProject) {
          this.$notify({
            group: 'base',
            type: 'error',
            title: 'No active project found',
            text: 'You need to select a project in order to continue'
          })
          return false
        }
        else {
          return true
        }
      },
      fetchTemplates () {
        if(!this.activeProject) {
          return null;
        }
        this.$store.dispatch('templates/fetchTemplates', this.activeProject.id)
      },
      async onGetURL (item) {
        this.storageService.getDownloadURL(item.fullPath)
          .then((url) => {
            window.open(url)
          })
          .catch((error) => {
            console.error(error)
            this.$notify({
              group: 'base',
              type: 'error',
              title: 'Oops, something went wrong',
              text: 'Could not resolve the link, please try again'
            })
          })
      },
      onOption(option, item) {
        if (option === 'download') {
          this.onGetURL(item)
        }
        else if (option === 'edit') {
          this.onEditItem(item)
        }
        else if (option==='delete') {
          this.onDeleteItem(item)
        }
      },
      onCreateItem () {
        this.resetEditingObject()
        
        if (!this.access.templates) {
          this.$emit('showSnackbar', {
            text: "You've reached the limit for your subscription plan.",
            button: "Upgrade",
            routeTo: "account",
          });
          return null;
        }

        this.dialogUpload = true
      },
      onEditItem (item) {
        this.editingObject = JSON.parse(JSON.stringify(item))
        this.editingObject.editMode = true
        this.dialogUpload = true
      },
      onDeleteItem (item) {
        this.editingObject = item
        this.dialogConfirmDelete = true
      },
      onDeleteMultipleItems () {
        if (this.activeProject.id) {
          this.$store
            .dispatch(
              "templates/deleteMultipleItems",
              this.selected
            )
            .then(() => {
              this.$notify({
                group: "base",
                type: "success",
                title: "Items deleted",
                text: "The selected items has been successfully deleted.",
              });
              this.selected = [];
            })
            .catch((error) => {
              console.log(error);
              this.$notify({
                group: "base",
                type: "error",
                title: "Oops, something went wrong",
                text: "The items has not been deleted. Please try again.",
              });
            });
          this.dialogMultipleDelete = false;
        }
      },
      onCreateEditTemplate () {
        if(this.editingObject.editMode) {
          this.editTemplate()
        }
        else {
          this.createTemplate()
        }
      },
      createTemplate () {
        if(!this.verifyActiveProject) {
          return null;
        }

        const item = this.editingObject
        item.projectId = this.activeProject.id
        item.companyId = this.company.id
        item.createdBy = this.user.id;
        item.updatedBy = this.user.id;

        this.$store.dispatch('templates/createTemplate', item)
          .then(() => {
            this.$notify({
              group: 'base',
              type: 'success',
              title: 'Item created',
              text: 'The template has successfully been created'
            })
            this.dialogUpload = false
            this.resetEditingObject()
          })
          .catch(() => {
            this.$notify({
              group: 'base',
              type: 'error',
              title: 'Oops, something went wrong',
              text: 'That did not go according to plan. The item was not created, please try again'
            })
          });
      },
      editTemplate () {
        if(!this.verifyActiveProject) {
          return null;
        }

        const item = this.editingObject
        item.projectId = this.activeProject.id
        item.companyId = this.company.id
        item.updatedBy = this.user.id;
        
        this.$store.dispatch('templates/editTemplate', item)
          .then(() => {
            this.$notify({
              group: 'base',
              type: 'success',
              title: 'Item updated',
              text: 'The item has been successfully updated'
            })
            this.dialogUpload = false
            this.resetEditingObject()
          })
          .catch(() => {
            this.$notify({
              group: 'base',
              type: 'error',
              title: 'Oops, something went wrong',
              text: 'That did not go according to plan. The item was not updated, please try again'
            })
          });
      },
      deleteTemplate () {
        if(!this.verifyActiveProject) {
          return null;
        }

        const item = this.editingObject
        //this.templateService.deleteFile(this.editingObject.fullPath)
        this.$store.dispatch('templates/deleteTemplate', item)
          .then(() => {
            this.$notify({
              group: 'base',
              type: 'success',
              title: 'Item deleted',
              text: 'The item was successfully deleted'
            })
            this.dialogConfirmDelete = false
            this.resetEditingObject()
          })
          .catch((error) => {
            console.log(error);
            this.$notify({
              group: 'base',
              type: 'error',
              title: 'Oops, something went wrong',
              text: 'The item was not deleted, please try again'
            })
          })
      },
    },
  }
</script>
